import './icon.less'
import SvgPolicyParameters from '../../../../../../assets/inlineSvg/icon-policy-parameters.svg'
import SvgPolicyParameterAttribute from '../../../../../../assets/inlineSvg/icon-policy-param-attribute.svg'
import FilesSvg from '../../../../../../assets/inlineSvg/files-icon.svg'
import React from 'react'
import { Shield } from 'phosphor-react'

export const PolicyParametersIcon = () => {
  return (
    <div className="policy-settings-colored-icon policy-paramters-icon">
      <SvgPolicyParameters />
    </div>
  )
}

export const PolicySettingsIcon = () => {
  return (
    <div className="policy-settings-colored-icon policy-settings-icon">
      <Shield />
    </div>
  )
}

export const CreatePolicyParametersIcon = () => {
  return (
    <div className="policy-settings-colored-icon policy-settings-icon">
      <SvgPolicyParameterAttribute />
    </div>
  )
}

export const BasicDetailsIcon = () => {
  return (
    <div className="policy-settings-colored-icon basic-details-icon">
      <FilesSvg />
    </div>
  )
}
